<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <!-- <div class="part-one-content"></div> -->
                </div>
            </div>
            <div style="position: relative; top: -3.7rem">
                <div class="desc-box">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div>为吸引高层次体育人才落户成都，助力世界赛事名城建设，经市体育局、市公安局和市人社局研究，决定对取得相应技术等级的运动员、裁判员可按程序办理入户手续。</div>
                </div>
                <div class="part-three-extra">
                    <img src="../assets/imgs/126/part-1-title.png" class="part-two-title-img" />
                    <div class="main-content" style="margin-top: 0.6rem">
                        <div class="part-four-title">一、运动员</div>
                        <div class="part-four-items">
                            获得国际运动健将、运动健将和一级运动员技术等级的成都市外的运动员。
                        </div>
                    </div>
                    <div class="main-content" style="margin-top: 0.6rem">
                        <div class="part-four-title">二、裁判员</div>
                        <div class="part-four-items">
                            获得各体育运动项目国家级裁判员和国际单项体育组织有关裁判技术等级认证的成都市外的国际裁判员。
                        </div>
                    </div>

                </div>
                <div class="part-two">
                    <img src="../assets/imgs/126/part-2-title.png" class="part-two-title-img" />
                    <div style="
                        margin-top: 1.44rem;
                        font-size: 0.3rem;
                        font-weight: 500;
                        color: #333333;
                        line-height: 0.44rem;
                        text-align: left;
                    ">
                    </div>
                    <div class="part-two-content" style="margin-top: 0.23rem">
                        <div style="margin-bottom: 0.22rem; position: relative">
                            <div class="part-two-dot">1</div>
                            申请人有效身份证原件及复印件；
                        </div>
                        <div style="margin-bottom: 0.22rem; position: relative">
                            <div class="part-two-dot">2</div>
                            运动员持运动员技术等级证书原件和复印件，或在国家体育总局官网下载技术等级认证材料；裁判员需持全国或地方单项协会技术等级认证材料，或国际单项体育组织出具的等级认证材料；
                        </div>
                        <div style="margin-bottom: 0.22rem; position: relative">
                            <div class="part-two-dot">3</div>
                            申请人获得的奖励证书等佐证材料；
                        </div>
                        <div style="margin-bottom: 0.22rem; position: relative">
                            <div class="part-two-dot">4</div>
                            成都市运动员、裁判员入户资格认证申请表；
                        </div>
                        <div style="margin-bottom: 0.22rem; position: relative">
                            <div class="part-two-dot">5</div>
                            其他相关资料。
                        </div>
                    </div>
                </div>
                <div class="part-four">
                    <img src="../assets/imgs/126/part-3-title.png" class="part-two-title-img" />
                    <div class="main-content">
                        <div class="part-four-items">
                            <div class="title-bg">申请人填报基本情况</div>
                            <div class="part-four-content1">
                                申请人下载并按要求如实填写《成都市运动员、裁判员入户资格认证申请表》。
                            </div>
                        </div>
                        <div class="part-four-items">
                            <div class="title-bg title-bg2">
                                <div class="extendFont">区（市）县体育部门进行资格审核</div>
                            </div>
                            <div class="part-four-content1">
                                申请人携带申请材料到拟落户单位所在区（市）县体育行政部门审核入户资格条件。
                            </div>
                        </div>
                        <div class="part-four-items">
                            <div class="title-bg title-bg3">市体育局出具落户意见</div>
                            <div class="part-four-content1">
                                成都市体育局根据全市竞技体育发展战略布局、区（市）县体育行政部门的请示资料和申请人的资质条件，进行综合研判和复核审查。
                            </div>
                        </div>
                        <div class="part-four-items">
                            <div class="title-bg title-bg4">
                                <div class="extendFont">人才服务机构开具入户联系函</div>
                            </div>
                            <div class="part-four-content1">
                                申请人持市体育局签署落户意见的《成都市运动员、裁判员入户资格认证申请表》，到市或区（市）县人社部门的人才服务机构开具《成都市运动员、裁判员入户联系函》。
                            </div>
                        </div>
                        <div class="part-four-items" style="border:none">
                            <div class="title-bg title-bg5">公安机关办理入户</div>
                            <div class="part-four-content1">
                                申请人持《成都市运动员、裁判员入户联系函》，按本人或直系亲属拥有的合法稳定住所、单位集体户、人才服务中心集体户顺序到拟入户地公安机关申请办理本人入户。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/126/part-4-title.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61885937">028-61885937</a>
                                <span style="margin-left: 0.5rem;color: #1355FF;">范霁</span>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市体育局青少年体育处（竞技体育处）
                        </div>
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61885330">028-61885330</a>
                                <span style="margin-left: 0.5rem;color: #1355FF;">王晋颖</span>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市体育局人事处
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <call phone="028-61885937"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";

export default {
    name: "",
    data() {
        return {

        };
    },
    components: {
        // bottom,
        call,
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .desc-box {
        width: 6.85rem;
        background: #fff;
        border-radius: 0.28rem;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 1.2rem;
        position: relative;
        color: #4E4E4E;
        font-size: 0.26rem;

        img {
            width: 6.85rem;
            height: 2.12rem;
            margin-top: -0.6rem;
        }

        div {
            padding: 0.36rem;
            line-height: 1.7;
            text-align: left;
        }
    }

    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        width: 7.5rem;
        min-height: 7.2rem;
        box-sizing: border-box;
        padding-bottom: 0.3rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            min-height: 5.84rem;
            background: url(../assets/imgs/126/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                padding-bottom: 0.2rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;
                padding-bottom: 0.35rem;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: -0.18rem;
                    width: 7.03rem;
                    height: 1.37rem;
                }

                .part-one-title {
                    margin-top: 0.98rem;
                    text-align: left;
                    margin-left: 0.34rem;
                }

                .part-one-text {
                    margin-top: 0.16rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.2rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 0.16rem;
        padding-left: 0.25rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-two-title {
            text-align: left;
            margin-left: 0.33rem;
            margin-bottom: 0.22rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.35rem;
            }
        }

        .part-two-items {
            width: 6.35rem;
            padding-bottom: 0.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding: 0.31rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.22rem;
        }

        .part-two-content {
            margin-top: 0.2rem;
            margin-bottom: 0.3rem;
            width: 6.22rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 0.34rem 0.24rem 0.15rem 0.67rem;
            font-size: 0.26rem;
            // //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;

            .part-two-dot {
                position: absolute;
                top: 0;
                left: -0.46rem;
                width: 0.36rem;
                height: 0.36rem;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 0.21rem;
                background: #739bfe;
                border-radius: 50%;
            }
        }
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 0.28rem;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;
        padding-bottom: 0.35rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.1rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.5rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;
            padding-bottom: 0.2rem;

            .part-four-items {
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }
    }

    .part-three-extra {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 0.15rem;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;
        padding-bottom: 0.35rem;

        .circle-title {
            font-weight: bold;
            width: 100%;
            // height: 0.67rem;
            font-size: 0.3rem;

            // border: 1px solid red;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #333;
            margin-bottom: 0.5rem;
            margin-top: 0.2rem;

            .circle {
                width: 0.22rem;
                height: 0.22rem;
                border: 0.06rem solid #FF6D60;
                border-radius: 50%;
                margin-right: 0.05rem;
            }
        }

        .main-content {
            margin-top: 0.8rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.5rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;
            padding-bottom: 0.2rem;
            position: relative;
            // margin-bottom: 0.8rem;

            .part-four-title {
                text-align: left;
                position: absolute;
                top: 0;
                left: 50%;
                width: 2.98rem;
                font-size: 0.32rem;
                background-color: #739bfeff;
                color: #fff;
                border-radius: 20px;
                text-align: center;
                padding: 0.18rem 0.2rem;
                transform: translate(-50%, -50%);
                white-space: nowrap;
            }

            .part-four-items {
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;

                &>p {
                    display: flex;
                    align-items: center;
                    font-size: 0.26rem;
                    color: #4E4E4E;
                    font-weight: bold;
                    margin-top: 0.3rem;

                    img {
                        width: 0.39rem;
                        height: 0.39rem;
                        margin-right: 0.14rem;
                    }
                }
            }
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.2rem 0.25rem 0.35rem 0.25rem;

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.9rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                position: relative;
                font-size: 0.26rem;
                // //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                padding-bottom: 0.35rem;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.34rem;
                    // //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                }

                .title-bg2 {
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                }

                .extendFont {
                    min-width: 7rem;
                    position: absolute;
                    top: 50%;
                    left: 0.58rem;
                    transform: translateY(-50%);
                }

                .title-bg3 {
                    width: 5rem;
                    height: 0.6rem;
                    background: url(../assets/imgs/Relocationallowance/part4-3.png);
                    background-size: 100% 100%;
                }

                .title-bg4 {
                    background: url(../assets/imgs/craft/part4-4.png);
                    background-size: 100% 100%;
                }

                .title-bg5 {
                    background: url(../assets/imgs/121/part5.png);
                    background-size: 100% 100%;
                }

                .title-bg6 {
                    background: url(../assets/imgs/121/part6.png);
                    background-size: 100% 100%;
                }

                .inside-title {
                    font-weight: 800;
                }

                .part-four-content2 {
                    font-weight: bolder;
                }
            }
        }
    }

    .zccl {
        position: relative;
        margin-top: 0.22rem;
        font-size: 0.26rem;

        .top {
            width: 7.03rem;
            height: 1.37rem;
            margin-left: -0.18rem;
        }

        .content {
            width: 6.85rem;
            background: #E8EEFF;
            margin: -0.45rem auto 0;
            padding: 0.33rem;
            box-sizing: border-box;
            border-radius: 0rem 0rem 0.26rem 0.26rem;
            padding-top: 0.28rem;

            font-weight: 500;
            text-align: left;
            color: #4e4e4e;

            .des {
                color: #4e4e4e;
                text-align: left;
                background: #ffffff;
                border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                padding: 0.35rem 0.23rem 0.3rem;
                margin-top: 0.2rem;
                position: relative;
                text-align: left;
                line-height: 0.44rem;

                color: #4E4E4E;
                font-size: 0.26rem;
                font-weight: normal;

                .title {
                    font-weight: bold;
                    position: absolute;
                    top: -0.6rem;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 100%;
                    // height: 0.67rem;
                    font-size: 0.3rem;

                    // border: 1px solid red;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .circle {
                        width: 0.22rem;
                        height: 0.22rem;
                        border: 0.06rem solid #FF6D60;
                        border-radius: 50%;
                    }
                }

            }
        }
    }

}
</style>
